export const popUpEnum = {
  MANAGERCALL: 'ManagerCall',
  TECHNICIANVISIT: 'TechnicianVisit',
  FOLLOWUPREFUND: 'FollowUpRefund',
  REFUND: 'Refund',
  PLANCHANGE: 'PlanChange',
  ABROAD_PACKAGE: 'AbroadPackage',
  CUSTOMER_DEVLIVERIES: 'CustomerDeliveries',
  FINANCE_ISSUE: 'FinanceIssue',
  COUPON_RECEIVED: 'CouponReceived',
};

export const onTrackerInitPopupEnum = {
  AccountHasDebt: {
    id: 'AccountHasDebt',
    icon: require('./images/popups/error.svg'),
    title: 'יש לך יתרת חוב בחשבון',
    description: 'יש להסדיר את התשלום בהקדם <br />כדי להימנע מהפסקת השירות',
    buttonText: 'לתשלום החוב',
    buttonAction: 'debtPayment',
  },
  PaymentMethodIssue: {
    id: 'PaymentMethodIssue',
    icon: require('./images/popups/creditCard.svg'),
    title: 'אמצעי התשלום שלך לא מעודכן',
    description: 'חשוב לעדכן בהקדם את אמצעי התשלום <br /> כדי להימנע מהפסקת השירות',
    buttonText: 'עדכון אמצעי תשלום',
    buttonAction: 'updatePaymentMethod',
  },
  DebtAndPaymentMethodIssue: {
    id: 'DebtAndPaymentMethodIssue',
    icon: require('./images/popups/error.svg'),
    title: 'קיימת בחשבונך יתרת חוב,<br /> ואמצעי התשלום שלך לא מעודכן',
    description: 'יש להסדיר את החוב ולעדכן אמצעי תשלום כדי<br /> להימנע מהפסקת השירות',
    buttonText: 'לתשלום ועדכון אמצעי תשלום',
    buttonAction: 'debtPayment',
  },
};
